import Vue from "vue"
import VueRouter from "vue-router"
import Home from "../views/Home.vue"

Vue.use(VueRouter)

const routes = [
  {
    path: "/",
    name: "home",
    component: Home,
    meta: {
      keepAlive: true,
    },
  },
  {
    path: "/car/:carid",
    name: "carpage",
    props: true,
    component: () => import("@/views/CarPage"),
  },
  {
    path: "/search",
    name: "search",
    component: () => import("@/views/SearchResult"),
    beforeEnter: (to, from, next) => {
      if (to.query.q !== undefined) {
        next()
      } else {
        next("/")
      }
    },
  },
  {
    path: "/brand/:brandname",
    name: "brand",
    component: () => import("@/views/BrandResult"),
  },
  {
    path: "/support",
    name: "support",
    component: () => import("@/views/Support"),
  },
  {
    path: "/contact",
    name: "contact",
    component: () => import("@/views/Contact"),
  },
  {
    path: "/privacy-policy",
    name: "privacypolicy",
    component: () => import("@/views/PrivacyPolicy")
  },
  {
    path: "*",
    redirect: "/",
  },
]

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.meta.keepAlive && savedPosition) {
      return savedPosition
    }
    return { x: 0, y: 0 }
  },
})

export default router
